export default "__VITE_ASSET__XWcDWK9U__"